import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import AlertIcon from "../../../sources/Icons/Alerta.svg";

export default function NoDebt() {
	return (
		<Box sx={{ display: "grid", width: "100%", height: "100%" }}>
			<Stack
				direction={"row"}
				sx={{ placeSelf: "center", alignItems: "center" }}
			>
				<Stack direction={"column"} spacing={1}>
					<Typography variant="subtitle">
						No cuentas con algún adeudo pendiente
					</Typography>
					<Typography variant="content">
						En esta pantalla aparecerá automáticamente el adeudo que
						tengas pendiente
					</Typography>
				</Stack>
				<Avatar variant="IconLarge" src={AlertIcon} />
			</Stack>
		</Box>
	);
}
